import type { PalletStatus } from '@stopal/shared/pallet-status'

import type { StatusPresetMap } from './types'

// Single-source taxonomy: the value set and the reached-customer predicate
// live in @stopal/shared (the DB enum derives from the same array).
export {
  hasReachedCustomer,
  type PalletStatus,
} from '@stopal/shared/pallet-status'

export const palletStatusPresets: StatusPresetMap<PalletStatus> = {
  assembling: { label: 'Assembling', tone: 'neutral' },
  ready_for_delivery: { label: 'Ready for Delivery', tone: 'info' },
  in_transit_to_user: { label: 'In Transit to Customer', tone: 'progress' },
  at_user: { label: 'At Customer', tone: 'success' },
  in_transit_to_warehouse: {
    label: 'In Transit to Warehouse',
    tone: 'warning',
  },
  stored: { label: 'Stored', tone: 'success' },
  in_transit_transfer: { label: 'In Transit Transfer', tone: 'muted' },
  returned: { label: 'Returned', tone: 'success' },
  decommissioned: { label: 'Decommissioned', tone: 'critical' },
  at_scan_go_place: { label: 'At Scan & Go', tone: 'info' },
}

/**
 * Look up a human label for a pallet status, returning the raw status (or
 * a fallback for null) when it isn't in the preset map. Use this instead
 * of `palletStatusPresets[status as keyof …]?.label ?? status` to keep
 * call sites free of unsafe `as` casts.
 */
export function palletStatusLabel(
  status: string | null | undefined,
  fallback = 'Unknown',
): string {
  if (!status) return fallback
  const entry = Object.entries(palletStatusPresets).find(([k]) => k === status)
  return entry?.[1].label ?? status
}
